// import axios from '@/plugins/axios'
import api from '@/lib/api'

const state = {
    profile: {
        firstName: '',
        lastName: '',
        email: ''
    },
    users: [],
    roles: []
}

const getters = {
    profile(state) {
        return state.profile
    },
    fullUserList(state) {
        return state.users
    },
    fullRolesList(state) {
        return state.roles
    }
}

const actions = {
    async getFullRolesList({ commit }) {
        let rolesResponse = await api.user.getUsersRoles()

        commit('GET_ROLES', rolesResponse.data)
    },
    resetPassword({commit}, resetPassword) {
        commit('RESET_PASSWORD', resetPassword)
    },
    forgotPassword({commit}, forgotPassword) {
        commit('FORGOT_PASSWORD', forgotPassword)
    },
}

// mutations
const mutations = {
    GET_PROFILE(state, payload) {
        state.profile = payload
    },
    SET_PROFILE(state, payload) {
        state.profile = payload
    },
    GET_USERS(state, payload) {
        state.users = payload
    },
    GET_ROLES(state, payload) {
        state.roles = payload
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}